/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Professionals/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Professionals({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Professionals",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 18,
  height = 18,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#D7598E"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Professionals.Svg"
  data-view-path={viewPath}
 viewBox="0 0 18 18"
 style={{'--as-1-wPsTQ': alignSelf,'--mt-2-wPsTQ': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-wPsTQ': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-wPsTQ': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-wPsTQ': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-wPsTQ': opacity,'--w-10-wPsTQ': typeof width === 'number' ? `${width}px` : width,'--h-11-wPsTQ': typeof height === 'number' ? `${height}px` : height,'--f-12-wPsTQ': fill,'--a-7-wPsTQ': isAnimated ? animation : "none",'--sd-8-wPsTQ': isAnimated ? strokeDashoffset : 0,'--sd-9-wPsTQ': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Professionals.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M3.124 3.516C3.124 2.679 3.802 2 4.639 2h4.79c.838 0 1.516.679 1.516 1.516v3.487a3.228 3.228 0 00-.711 4.828 4.547 4.547 0 00-2.1 3.836c0 .113.011.223.034.33H3.624l-.048-.003H2.75a.75.75 0 110-1.5h.374V7.62H7.47a.625.625 0 100-1.25H3.124v-1.35h2.96a.625.625 0 000-1.25h-2.96v-.253zm11.54 6.21a1.98 1.98 0 11-3.96 0 1.98 1.98 0 013.96 0zm-1.98 2.64a3.3 3.3 0 00-3.3 3.3c0 .183.147.33.33.33h5.94a.33.33 0 00.33-.33 3.3 3.3 0 00-3.3-3.3z"
 style={{'--f-12-wPsTQ': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}